import { render, staticRenderFns } from "./RelatorioAuditoriaForm.vue?vue&type=template&id=4222a448&scoped=true&"
import script from "./RelatorioAuditoriaForm.vue?vue&type=script&lang=js&"
export * from "./RelatorioAuditoriaForm.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioAuditoriaForm.vue?vue&type=style&index=0&id=4222a448&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222a448",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
